import { Link, NavLink } from "react-router-dom";
import { useState } from "react";
import { Menu, X } from "lucide-react";
import { LOGO_URL } from "@/lib/flow";
import SocialIcons from "@/components/site/SocialIcons";

const links = [
    { to: "/", label: "Home" },
    { to: "/products", label: "Catalog" },
    { to: "/reviews", label: "Reviews" },
    { to: "/book", label: "Installation" },
    { to: "/repair", label: "Repair" },
    { to: "/blog", label: "Blog" },
    { to: "/faq", label: "FAQ" },
];

export default function Navbar() {
    const [open, setOpen] = useState(false);
    return (
        <header
            className="sticky top-0 z-40 bg-white/85 backdrop-blur border-b border-flow-line"
            data-testid="site-navbar"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-10 h-20 flex items-center justify-between">
                <Link to="/" className="flex items-center gap-3" data-testid="nav-logo-link">
                    <img src={LOGO_URL} alt="FlowLux" width="80" height="80" className="h-10 w-10 object-contain" />
                    <div className="leading-tight">
                        <div className="text-flow-blue text-lg tracking-[0.18em]" style={{ fontWeight: 300 }}>
                            FLOWLUX
                        </div>
                        <div className="text-[10px] tracking-[0.28em] text-flow-muted uppercase">
                            Smart Toilets
                        </div>
                    </div>
                </Link>

                <nav className="hidden md:flex items-center gap-10">
                    {links.map((l) => (
                        <NavLink
                            key={l.to}
                            to={l.to}
                            end={l.to === "/"}
                            data-testid={`nav-link-${l.label.toLowerCase()}`}
                            className={({ isActive }) =>
                                `text-sm tracking-wide transition-colors ${
                                    isActive ? "text-flow-blue" : "text-flow-ink hover:text-flow-blue"
                                }`
                            }
                        >
                            {l.label}
                        </NavLink>
                    ))}
                </nav>

                <div className="hidden md:flex items-center gap-3">
                    <Link to="/quote" className="fl-btn-primary text-sm" data-testid="nav-cta-quote">
                        Contact
                    </Link>
                    <SocialIcons size={16} testIdPrefix="nav-social" />
                </div>

                <button
                    className="md:hidden p-2"
                    onClick={() => setOpen((v) => !v)}
                    data-testid="nav-mobile-toggle"
                    aria-label="Open menu"
                >
                    {open ? <X size={20} /> : <Menu size={20} />}
                </button>
            </div>

            {open && (
                <div className="md:hidden border-t border-flow-line bg-white" data-testid="nav-mobile-menu">
                    <div className="px-6 py-6 flex flex-col gap-5">
                        {links.map((l) => (
                            <NavLink
                                key={l.to}
                                to={l.to}
                                end={l.to === "/"}
                                onClick={() => setOpen(false)}
                                className="text-base tracking-wide text-flow-ink"
                                data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
                            >
                                {l.label}
                            </NavLink>
                        ))}
                        <Link
                            to="/quote"
                            onClick={() => setOpen(false)}
                            className="fl-btn-primary self-start text-sm"
                            data-testid="nav-mobile-cta-quote"
                        >
                            Contact
                        </Link>
                    </div>
                </div>
            )}
        </header>
    );
}
